import './App.css';
import Homepage from './Components/Homepage/homePage';

function App() {
  return (
    <>
    <Homepage/>
    </>
  );
}

export default App;
